import { Route, Routes } from '@angular/router';
import { ViewerComponent } from './views/viewer/viewer.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { ViewerMode } from '@models/enums/App/ViewerMode.enum';
import { LoginComponent } from '@views/login/login.component';
import { authGuard } from '@helpers/guards/auth.guard';

/** Construye el mismo árbol funcional variando únicamente la entrada de login. */
function createRoutes(loginRoute: Route): Routes {
  return [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'not-found'
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('@views/admin/admin.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [authGuard],
  },
  loginRoute,
  {
    path: ':team',
    component: ViewerComponent,
    data: { mode: ViewerMode.View }
  },
  {
    path: '**',
    component: NotFoundComponent
  }
  ];
}

/** Árbol standalone con login por credenciales contra OneLogin. */
export const routes: Routes = createRoutes({
  path: 'auth/login',
  component: LoginComponent,
});

/** Árbol para hosts que ya son propietarios de la sesión administrativa. */
export const embeddedRoutes: Routes = createRoutes({
  path: 'auth/login',
  pathMatch: 'full',
  redirectTo: 'admin/list',
});
